import { type AnyRouter, createRouter } from '@tanstack/react-router';
import { trackSessionEvent } from '@services/session-tracker/sessionTracker';
import { routeTree } from '../routes';
import { createAppHistory } from './appHistory';
import { bindRouter } from './instance';
import { parseSearch, stringifySearch } from './search';

// The repo tsconfig is not strictNullChecks, which TanStack's option types reject.
export const router = (
  createRouter as unknown as (options: object) => AnyRouter
)({
  routeTree,
  history: createAppHistory(),
  basepath: import.meta.env.BASE_URL,
  parseSearch,
  stringifySearch,
  defaultPreload: false,
});

bindRouter(router);

router.subscribe('onResolved', () =>
  trackSessionEvent('Navigate', { path: window.location.pathname }),
);
